import React, { useState } from 'react';
import { Button, Alert, Spinner } from 'react-bootstrap';
import { syncStudents, SyncStudentsResponse } from '../../services/api';

const StudentSyncButton: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<SyncStudentsResponse | null>(null);

  const handleSync = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await syncStudents();
      setSuccess(result);

      // Auto-dismiss success message after 4 seconds
      setTimeout(() => setSuccess(null), 4000);
    } catch (err: any) {
      const errorMessage = err.response?.data?.detail || 'Failed to sync students from GoHighLevel';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {success && (
        <Alert variant="success" className="mb-3" dismissible onClose={() => setSuccess(null)}>
          <strong>✓ Sync Complete!</strong>
          <div className="mt-2">
            <small>
              • Added: {success.added} students<br />
              • Updated: {success.updated} students<br />
              • Removed: {success.removed} students<br />
              • Total: {success.total} students in database
            </small>
          </div>
        </Alert>
      )}

      {error && (
        <Alert variant="danger" className="mb-3" dismissible onClose={() => setError(null)}>
          <strong>✗ Sync Failed</strong>
          <div className="mt-2">
            <small>{error}</small>
          </div>
        </Alert>
      )}

      <Button
        variant="success"
        onClick={handleSync}
        disabled={loading}
        size="sm"
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Syncing...
          </>
        ) : (
          'Sync Students Now'
        )}
      </Button>
    </div>
  );
};

export default StudentSyncButton;
